import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import api from "@/lib/api";
import { useActivity } from "@/context/ActivityContext";
import { Megaphone } from "lucide-react";

export default function PromoStrip() {
  const [promos, setPromos] = useState([]);
  const { tick } = useActivity();

  useEffect(() => {
    api.get("/promotions").then((r) => setPromos(r.data)).catch(() => {});
  }, [tick]);

  if (promos.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-4 sm:px-6 py-16">
      <div className="flex items-center gap-2 mb-8">
        <Megaphone className="h-5 w-5 text-yellow-400 text-glow-yellow" />
        <h2 className="font-heading text-2xl sm:text-3xl font-bold tracking-tight uppercase text-zinc-50">
          Promozioni
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
        {promos.map((p, i) => {
          const Wrapper = p.link ? "a" : "div";
          const wprops = p.link ? { href: p.link, target: "_blank", rel: "noopener noreferrer" } : {};
          return (
            <motion.div key={p.id} initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.05 }}>
              <Wrapper {...wprops} data-testid={`promo-${p.id}`}
                className="group block border border-zinc-800 bg-zinc-900 overflow-hidden hover:border-yellow-400/50 transition-colors duration-200">
                {p.image_url && (
                  <div className="h-40 overflow-hidden">
                    <img src={p.image_url} alt={p.title}
                      className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                  </div>
                )}
                <div className="p-6">
                  <h3 className="font-heading text-xl font-bold text-zinc-50">{p.title}</h3>
                  {p.description && <p className="mt-2 text-sm text-zinc-400 line-clamp-3">{p.description}</p>}
                </div>
              </Wrapper>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
